import { useEffect, useState } from 'react'
import { Widget } from '@typeform/embed-react'

export const Typeform = ({ id, metaIframeTitle, hidden, mode, serviceUrl }) => {

    const [referer, setReferer] = useState(null)
    const [category, setCategory] = useState(null)

    useEffect(() => {
        if (hidden?.referer) {
            const ref = document.referrer
            setReferer(ref)
        }

        if (hidden?.category && document.referrer) {
            const ref = document.referrer
            const contentUrl = `${serviceUrl}?referrer=${encodeURIComponent(ref)}`

            fetch(contentUrl)
                .then(res => res.json())
                .then(data => {
                    if (data?.category) {
                        setCategory(data.category)
                    }
                })
        }
    }, [hidden])

    if (mode === 'edit') {
        return <p>Form not viewable in edit mode. Enter preview to see it.</p>
    }

    const hiddenFields = {
        country: hidden?.country || undefined,
        segment: hidden?.segment || undefined,
        referer: referer || undefined,
        category: category || undefined
    }

    return (
        <Widget
            id={id}
            style={{ height: '75vh', width: '100%' }}
            hidden={hiddenFields}
            inlineOnMobile
            iframeProps={{ title: metaIframeTitle }}
        />
    )
}
